import React from "react"
import { Button } from "reactstrap"

const IconButton = ({ icon, onClick, size, text, color }) => {
  return (
    <Button color={color} size={size} onClick={onClick}>
      {icon && <span className={"mdi " + icon}></span>} {text}
    </Button>
  )
}

export default IconButton
